module.exports = __webpack_public_path__ + "img/fi.e8d0bd77.svg";